import * as React from "react";
import { Redirect } from "react-router-dom";

import { ROUTES } from "@config/app.routing";

import { useBreakpoint } from "@hooks/useBreakpoint";

interface Props {
  children: React.ReactNode;
}

const MobileOnlyGuard = (props: Props): React.ReactElement => {
  const { mobile, tablet } = useBreakpoint("v1");

  const isMobile = mobile || tablet;

  return isMobile ? (
    <React.Fragment>{props.children}</React.Fragment>
  ) : (
    <Redirect push={false} to={ROUTES.BASE} />
  );
};

export { MobileOnlyGuard };

MobileOnlyGuard.displayName = "MobileOnlyGuard";
